// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".payment-layout[data-v-610ba344]{height:100vh;min-height:100%;display:grid;grid-template-rows:0fr 1fr 0fr}.page-footer[data-v-610ba344]{background-color:#fcfcfc;padding:20px 10px 10px;font-size:14px;color:#6c757d;bottom:5px;margin:0 auto}.copyright-link[data-v-610ba344]{text-decoration:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
